import { observer } from 'mobx-react-lite';
import { topNotificationStore } from '../../model/store/NotificationStore';
import { SingleTopNotification } from './SingleTopNotification';
import styles from './TopNotification.module.scss';

export const TopNotification = observer(() => {
  const { notifications, isVisible } = topNotificationStore;

  if (!isVisible) return null;

  return (
    <div className={styles.listContainer}>
      {notifications.map((notification) => (
        <SingleTopNotification
          key={notification.id}
          notification={notification}
        />
      ))}
    </div>
  );
});
